module.exports = __webpack_public_path__ + "img/tel.70e0150d.png";